export default __webpack_public_path__ + "static/media/app7-analyze.94c7aca0.gif";